module.exports = __webpack_public_path__ + "static/media/icon-relax.60069f48.svg";